import { render } from "./addlibrary.vue?vue&type=template&id=372b797a"
import script from "./addlibrary.vue?vue&type=script&lang=js"
export * from "./addlibrary.vue?vue&type=script&lang=js"

import "./addlibrary.vue?vue&type=style&index=0&id=372b797a&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__